// Page name decided 2026-08-03: "My Library" (was working-named "My Uploads").
// Kept as a single constant so any future rename touches one line. HomeSideBar
// imports this file eagerly, so it must stay import-light.
// NOTE: /home/library is the Mattoboard catalog Library — this page is the
// user's own uploads and deliberately lives at /home/my-library.
export const MY_LIBRARY_LABEL = "My Library";

export const MY_LIBRARY_ROUTE = "/home/my-library";

// The board editor's MY IMAGES (userImages) as a page, listed under My Library.
export const REFERENCE_IMAGES_LABEL = "Reference Images";

export const REFERENCE_IMAGES_ROUTE = "/home/reference-images";

export const UPLOADS_PAGE_SIZE = 20;

// Studio Library: the workspace's most-used products (auto-filled by board
// placements, plus manual adds). Feature-flagged: studio_library.
export const STUDIO_LIBRARY_LABEL = "Studio Library";

export const STUDIO_LIBRARY_ROUTE = "/home/studio-library";

// Body of the remove confirm (page and board-editor panel).
export const STUDIO_LIBRARY_REMOVE_BODY =
  "Use counts will be lost. Placing a product on a board adds it back.";
